export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])},
          "clear_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limpiar"])}
        }
      },
      "en": {
        "labels": {
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to the list"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
          "clear_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clear"])}
        }
      }
    }
  })
}